import { DeliveryExperience } from "src/app/_enums/general/delivery-experience.enum";
import { ShippingServiceMethod } from "../../shipping-rule.model";
import ShippingLabelModel from "./shipping-label.model";
import { BaseModel } from '../../_base.model';
import { OrderBoxModel } from "../../orders/order-boxes/order-box.model";

export default class ShipmentModel extends BaseModel {
    id?: number;
    orderBoxIds: number[];
    orderBoxes: OrderBoxModel[]
    shippingDate: string;
    shippingAccountId: number;
    deliveryExperience: DeliveryExperience = DeliveryExperience.Unspecified;
    shippingServiceMethod: ShippingServiceMethod;
    shippingLabels: ShippingLabelModel[];
    shippingRuleId: number;
    createdDate: string;
    estimatedDeliveryDate: string;
}
